import {Component, OnInit} from '@angular/core';
import {TransportationService} from '../api/transportation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public headerSegments = [];

  constructor(private transportationService: TransportationService) {
    this.getElements();
  }

  ngOnInit() {
  }

  getElements() {
    return this.transportationService.getAllTransportations().subscribe(
      res => this.headerSegments = res);
  }

  retourApp(){
    return window.location.href='https://promo.parker.com/promotionsite/parker-legris-transportation-applications/us/en/applications'
  }

}





